import { lazy } from "react";

export const LazyPreviouslyOrderedModal = lazy(() =>
  import(
    /* webpackChunkName: "retailer-product-page-header-previously-ordered-modal" */ "./PreviouslyOrderedModal"
  ).then((m) => ({ default: m.PreviouslyOrderedModal }))
);
